import { Subscription } from 'rxjs';

import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { DatatableConfigurationMapperService } from '../../../analytics-core/services/datatable-configuration.mapper.service';
import { EVENT_EMITTERS, PATHS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import * as _ from 'underscore';
import * as numeral from 'numeral';
import * as Highcharts from 'highcharts';

@Component({
	encapsulation: ViewEncapsulation.None,
	selector: 'app-r13-sem-conversions',
	styleUrls: ['./r13-sem-conversions.component.css'],
	templateUrl: './r13-sem-conversions.component.html'
})
export class R13SemConversionsComponent implements OnInit, OnDestroy, AfterViewInit {
	@Input() customchartconfiguration: any;
	@Input() uikitresponseconfig: any;
	@Input() colorsconfig: any;
	@Input() datatableconfig: any;
	@Input() key: string;
	@Input() legend: any;
	@Input() sectionclass: string;
	@Input() sectiontitle: string;
	@Input() nodatamessage: any;

	public reloadSubscription: Subscription;
	public widgetDataSubscription: Subscription;
	public colorPalette: ColorPalette;
	public semConversionsChartData: any[] = [];
	public semConversionsTableData: any[] = [];
	public showLoad = true;
	public hasData = true;
	public chartConfigResponse: any[] = [];
	public datatableconfigloy: any[] = [];
	public temp: any;
	public baseConfig: any;
	public chartConfig: any;
	public series: any;
	public toolTip: any;
	public axisdataSource: any;
	public conversionActioncolors: any;
	public colorArray: any;
	public donutData: any;
	public groupByData: any;
	public totalConversions: 0;
	public totalAllConversions: 0;
	public totalClicks: any;
	public conversionRate: 0;
	public metric: any;
	public isR13 = false;
	public tooltipOptions = {
		position: 'top',
		animation: 'fade',
		arrowSize: 'small',
		distance: 0,
		offset: 0,
		arrow: true,
		size: 'small',
		duration: 750,
		scale: 'small',
		dynamicTitle: true,
		theme: 'r13-sem-conversions'
	};

	protected DEFAULT_DEVICES = [{ device: 'desktop' }, { device: 'mobile' }, { device: 'tablet' }, { device: 'other' }];

	constructor(
		protected analyticsDataModel: AnalyticsDataModel,
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected dataTableService: DatatableConfigurationMapperService
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.customchartconfiguration = JSON.parse(decodeURI(this.customchartconfiguration));
		this.uikitresponseconfig = this.uikitresponseconfig ? JSON.parse(decodeURI(this.uikitresponseconfig)) : [];
		this.colorsconfig = this.colorsconfig ? JSON.parse(decodeURI(this.colorsconfig)) : [];
		this.datatableconfig = JSON.parse(decodeURI(this.datatableconfig));
		this.isR13 =
			this.analyticsDataModel.config.partner.directoryName === 'lee-r13' ||
			this.analyticsDataModel.config.partner.directoryName === 'default-r13'
				? true
				: false;
		this.baseConfig = {
			chartConfig: this.customchartconfiguration.chartConfig
		};
		this.datatableconfig.columns = this.dataTableService.generateColumnConfigurationForDataTable(
			this.datatableconfig.columns
		);
		if ((!this.nodatamessage || this.nodatamessage === 'undefined' || this.nodatamessage === 'null') && this.isR13) {
			this.nodatamessage = 'No Data to Display';
		} else {
			this.nodatamessage = 'No Data Available';
		}
	}

	ngAfterViewInit(): void {
		this.requestData();
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	requestData(): void {
		this.hasData = true;
		this.showLoad = true;
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success && response.data.length > 0) {
				this.hasData = true;
				this.processResponseData(response.data);
			} else {
				this.hasData = false;
			}
		});
	}

	processResponseData(responseData: any): void {
		this.semConversionsChartData = [];
		this.chartConfigResponse = [];
		responseData.sort((a, b) => parseInt(b.conversions) - parseInt(a.conversions));
		const responseDatArray = [];
		this.donutData = [];
		this.colorArray = [];
		if (responseData?.length <= 5) {
			responseData = responseData;
			this.groupByData = responseData;
		} else {
			let tempAllConversions = 0;
			let tempConversionaction = '';
			let tempConversions = 0;
			let tempclicks = 0;

			for (let i = 4; i < responseData?.length; i++) {
				tempAllConversions += Number(responseData[i]['all_conversions']);
				tempConversions += Number(responseData[i]['conversions']);
				tempclicks = Number(responseData[i]['clicks']);
			}
			let tempDataArray = {
				all_conversions: tempAllConversions.toString(),
				conversion_action: 'Additional',
				conversions: tempConversions.toString(),
				clicks: tempclicks.toString(),
				tooltip: 'All other conversion actions.'
			};
			let updatedRespData = responseData.splice(0, 4);
			updatedRespData.splice(4, 0, tempDataArray);
			responseData = updatedRespData;
			//this.responseData = responseData
		}
		this.groupByData = responseData.filter((obj) => {
			return obj['conversions'] != 0 || obj['all_conversions'] != 0;
		});
		this.groupByData = _.map(this.groupByData, (item) => {
			return {
				conversion_action: item['conversion_action'],
				conversions: item['conversions'],
				clicks: item['clicks'],
				tooltip: item['tooltip'],
				all_conversions: item['all_conversions']
			};
		});
		this.colorArray = ['primary-color', 'secondary-color', 'tertiary-color', 'quaternary-color', 'quinary-color'];
		this.series = [
			{
				innerSize: '46%',
				showInLegend: false,
				type: 'pie',
				startAngle: -90,
				endAngle: 90,
				size: '200%',
				borderWidth: 0,
				enableMouseTracking: true
			}
		];
		this.axisdataSource = [];
		this.conversionActioncolors = {};
		this.totalConversions = 0;
		this.totalAllConversions = 0;
		this.totalClicks = 0;
		this.conversionRate = 0;
		let count = 0;
		for (let i = 0; i < this.groupByData.length; i++) {
			this.totalConversions += Number(this.groupByData[i].conversions);
			this.totalAllConversions += Number(this.groupByData[i]['all_conversions']);
			this.conversionActioncolors[this.groupByData[i].conversion_action] = this.colorArray[i];
			this.groupByData[i].conversions = Number(this.groupByData[i].conversions).toLocaleString();
			const axisdataSource = {
				dataType: 'string',
				displayName: this.groupByData[i].conversion_action,
				readFrom: 'conversions',
				showInSeries: true,

				colorPalette: {
					color: this.colorsconfig[i].color,
					isCustom: false
				},
				rowIdentity: {
					key: 'conversion_action',
					value: this.groupByData[i].conversion_action
				}
			};
			this.axisdataSource.push(axisdataSource);
			this.series[0].axisDataSource = this.axisdataSource;
			this.series[0].name = this.groupByData[i].conversion_action;

			this.dataTableService.generateDatatableSourceDataFromConfig(this.groupByData[i], this.datatableconfig.columns);
		}
		this.totalClicks = Number(this.groupByData[0].clicks);
		const frmt_conversionRate =
			numeral((this.totalConversions / this.totalClicks) * 100).format('0, 0.00') === '100.00' ? '0' : '0,0.00';
		this.conversionRate = numeral((this.totalConversions / this.totalClicks) * 100).format(frmt_conversionRate);
		this.baseConfig.chartConfig.series = this.series;

		this.baseConfig.chartConfig.toolTip = {
			...this.baseConfig.chartConfig.toolTip,
			...{
				useHTML: true,
				pointFormat: '',
				style: {
					fontSize: '12px',
					'font-style': 'normal',
					'font-weight': 400
				},
				pointFormatter() {
					const series = this.series;
					let row = '';
					const header = `<table class='tooltip'>`;
					const footer = `</table>`;
					series.data.forEach((tooltipInfo) => {
						if (this.name == tooltipInfo.name && this.index == tooltipInfo.index) {
							row = `
								<tr><td style='text-align:left; color: ${tooltipInfo.color}'>${tooltipInfo.name}<td>
								<tr><td style='text-align:left;'> conversions </td><td style='text-align:right;'>${Highcharts.numberFormat(
									tooltipInfo.y,
									0
								)}</td></tr>`;
						}
					});
					return `${header}
									${row}
									${footer}`;
				}
			}
		};
		this.temp = {
			chartConfig: this.baseConfig.chartConfig,
			responseConfig: this.uikitresponseconfig
		};
		this.chartConfigResponse.push(this.temp);
		this.semConversionsChartData = this.groupByData;
		for (let i = 0; i < this.groupByData.length; i++) {
			this.semConversionsTableData[i] = this.groupByData[i];
			this.semConversionsTableData[i].color = this.colorArray[i];
		}
		this.semConversionsTableData = this.groupByData;
		this.metric = [
			{
				name: 'Conversions',
				value: this.totalConversions.toLocaleString(),
				tooltip:
					'An action that’s counted when someone interacts with your ad or free product listing, then takes an action you’ve defined as valuable to your business, such as a purchase or a phone call.'
			},
			{
				name: 'Conversion Rate',
				value: this.conversionRate + '%',
				tooltip: 'The average number of conversions per ad interaction, as a percentage.'
			},
			{
				name: 'All Conversions',
				value: this.totalAllConversions.toLocaleString(),
				tooltip:
					'A calculation of all the conversions that Google Ads drives for your business, including any actions being excluded from your tracking metrics.'
			}
		];
	}

	public getSemConversionsColor(conversion_action: string): string {
		return this.conversionActioncolors[conversion_action];
	}
}
